var TipHomeTotalClaim = '统计区内总的出险数量，即总报案数';
var TipHomeExpiredClamRate = '统计区内的满期出险率';
var TipHomeTotalPaid = '统计区内的所有赔款金额之和';
var TipHomeExpiredPaidRate = '统计区间内的满期赔付率（（已决赔款+未决赔款）/满期保费）';
var TipHomeEfficiency = '统计期内万元以下已结案案件的理赔时效（∑（结案时间-报案时间）/案件数量）';
var TipHomeClaimTrend = '统计区内总的出险数量，即总报案数';
var TipHomePaidTrend = '统计区间内每日的已决金额（保司已赔金额）、未决金额';
var TipHomeExpiredTrend = '统计区间内每日的满期赔付率（（已决赔款+未决赔款）/满期保费）';
var TipHomeEfficiencyTrend = '统计期内已结案案件的理赔时效（∑（结案时间-报案时间）/案件数量）';
// Second Home
var TipHomeClaimTotalClaim = '统计区内总的出险数量，即总报案数';
var TipHomeClaimExpiredRate = '统计区内的满期出险率';
var TipHomeClaimTotalInjured = '统计区内的已报案案件涉及到的人伤、人亡总数';
var TipHomeClaimInjuredRate = '统计区内的含人伤案件占总出险案件的百分比';
var TipHomePaymentTotalClaim = '统计区内的所有赔款金额之和';
var TipHomePaymentExpiredRate = '统计区间内的满期赔付率（（已决赔款+未决赔款）/满期保费）';
var TipHomePaymentEfficiency = '统计期内已结案案件的理赔时效（∑（结案时间-报案时间）/案件数量）';
var TipHomeExpiredTotalClaim = '统计区内的所有赔款金额之和';
var TipHomeExpiredRate = '统计区间内每日的满期赔付率（（已决赔款+未决赔款）/满期保费）';
var TipHomeEfficiencyProp = '统计期内万元以下已结案案件的理赔时效（∑（结案时间-报案时间）/案件数量）';
// detail
var TipSubClaimTrend = '统计区内每日出险的数量，即报案数';
var TipsSubClaimRank = '按照车型、保司、地区三个维度对统计区间内的出险情况进行排名，出险次数越多，排名越靠前。';
var TipSubPaidTrend = '统计区内每日的赔付情况，已决金额（当日赔款金额），未决金额（截止当日未决金额）';
var TipsSubPaidRank = '按照车型、保司、地区三个维度对统计区间内的赔付情况进行排名，赔款金额越高，排名越靠前。';
var TipsSubFactoryRank = '统计区间内案均修理厂排名，案均赔款金额越大，排名越靠前';
var TipSubExpiredTrend = '统计区间内的满期赔付率（（已决赔款+未决赔款）/满期保费）';
var TipsSubExpiredRank = '按照保司、地区两个维度对统计区间内的赔付情况进行排名，赔付率越高，排名越靠前。';
var TipSubEfficiencyTrend = '统计区间内已结案案件不同金额区间的赔付时效';
var TipsSubEfficiencyRank = '按照理赔金额维度对不同保司之间的理赔时效进行排名。理赔时效越快，排名越靠前。';
export { TipHomeTotalClaim, TipHomeExpiredClamRate, TipHomeTotalPaid, TipHomeExpiredPaidRate, TipHomeEfficiency, TipHomeClaimTotalClaim, TipHomeClaimExpiredRate, TipHomeClaimTotalInjured, TipHomeClaimInjuredRate, TipHomePaymentTotalClaim, TipHomePaymentExpiredRate, TipHomePaymentEfficiency, TipHomeExpiredTotalClaim, TipHomeExpiredRate, TipHomeEfficiencyProp, TipHomeClaimTrend, TipHomePaidTrend, TipHomeExpiredTrend, TipHomeEfficiencyTrend, TipSubClaimTrend, TipsSubClaimRank, TipSubPaidTrend, TipsSubPaidRank, TipsSubFactoryRank, TipSubExpiredTrend, TipsSubExpiredRank, TipSubEfficiencyTrend, TipsSubEfficiencyRank, };
